module.exports = __webpack_public_path__ + "static/media/mini_onboarding.7fc99a2e.svg";